import { TableConfig } from '@shared/interfaces/table/table-config';
import { Columns } from '@shared/interfaces/table/column-config';
import { MeteringPointMeteredDataSource } from '@app/api/dmc';
import { validFromPartialTable } from '@shared/partials/validfrom-partial.table';
import { validToPartialTable } from '@shared/partials/validto-partial.table';

/** A metered-data source row with its display texts resolved. */
export interface MeteringPointSourceRow extends MeteringPointMeteredDataSource {
  sourceText: string;
  /** Ja/Nej for meter relations; empty for calculation relations. */
  verificationMeterText: string;
}

/** Relations without an end date show an empty Gyldig til. */
export const meteringPointSourceValidToColumn: Columns<MeteringPointSourceRow> = {
  ...validToPartialTable,
  key: 'validTo',
  cellRendererParams: { hideEmpty: true },
};

/** Combined timeline of meter quadrants, calculation formulas and verification meters for a metering point. */
export const meteringPointSourceTable: TableConfig<MeteringPointSourceRow> = {
  selectable: true,
  selectableType: 'multiple',
  columns: [
    {
      title: 'meteringpoint.source.source',
      key: 'sourceText'
    },
    validFromPartialTable,
    meteringPointSourceValidToColumn,
    {
      title: 'meteringpoint.meter.controlmeter',
      key: 'verificationMeterText',
    },
  ],
};
